import { GetPlayerGames } from "@grassrootly/api/gateways/player";
import useBaseRequest from "../../api/BaseRequest";
import { store, useAppDispatch } from "@grassrootly/rn-core";
import { gameActions } from "../../api/game/GameReducer";
import { useLatestGame } from "../../api/game/GameSelector";
import React from "react";
import { useFocusEffect } from "@react-navigation/native";

export function useHome() {
  const dispatch = useAppDispatch();
  const game = useLatestGame();
  const { loading, execute } = useBaseRequest(GetPlayerGames, {
    onCompleted: (data) => {
      if (!data || !data.length) return;
      dispatch(gameActions.setGame(data[0]));
      dispatch(gameActions.setLatestGame(data[0].id));
    },
  });

  const getGames = React.useCallback(() => {
    const playerId = store.getState().auth?.user?.id;
    execute({ playerId });
  }, []);

  useFocusEffect(getGames);

  return { game, loading, getGames };
}
